import { render, staticRenderFns } from "./PatientDispenseForm.vue?vue&type=template&id=525cce94&"
import script from "./PatientDispenseForm.vue?vue&type=script&lang=js&"
export * from "./PatientDispenseForm.vue?vue&type=script&lang=js&"
import style0 from "./PatientDispenseForm.vue?vue&type=style&index=0&id=525cce94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports